import {
  ALERTS_TEXT,
  ALLERGY_NAME_NOT_UNIQUE,
  ALLERGY_NAME_NOT_VALID,
  apiErrorCodes,
  COUNT,
  EMAIL_NOT_UNIQUE_ERROR,
  EMAIL_TEXT,
  FILE_LOWER,
  FILE_TAG_LOWER,
  GENDER,
  ID_VERIFICATION_STATUSES,
  MESSAGE_TEXT,
  OFFSET,
  PATIENT_NOT_FOUND_ERROR,
  PATIENT_TEXT,
  PHONE_NUMBER_NOT_VALID,
} from '../../utils/constants'
import { LOGOUT } from '../../app/authState'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  ADD_ALERT,
  ADD_ALERT_ERROR,
  ADD_ALERT_SUCCESS,
  ADD_ALLERGY,
  ADD_ALLERGY_ERROR,
  ADD_ALLERGY_SUCCESS,
  ADD_MEDIA_FILE,
  ADD_MEDIA_FILE_ERROR,
  ADD_MEDIA_FILE_SUCCESS,
  DELETE_MEDIA_FILE_ERROR,
  DELETE_MEDIA_FILE_SUCCESS,
  CREATE_UPCOMING_VISIT_REMARK,
  CREATE_UPCOMING_VISIT_REMARK_ERROR,
  CREATE_UPCOMING_VISIT_REMARK_SUCCESS,
  DELETE_ALERT,
  DELETE_ALERT_ERROR,
  DELETE_ALERT_SUCCESS,
  DELETE_ALLERGY,
  DELETE_ALLERGY_ERROR,
  DELETE_ALLERGY_SUCCESS,
  EDIT_ALERT,
  EDIT_ALERT_ERROR,
  EDIT_ALERT_SUCCESS,
  GET_ALERTS_LIST,
  GET_ALERTS_LIST_ERROR,
  GET_ALERTS_LIST_SUCCESS,
  GET_AUDI_LOGS,
  GET_GET_AUDI_LOGS_ERROR,
  GET_GET_AUDI_LOGS_SUCCESS,
  GET_INTAKE_FORM,
  GET_INTAKE_FORM_ERROR,
  GET_INTAKE_FORM_SUCCESS,
  GET_INTAKE_FORMS,
  GET_INTAKE_FORMS_ERROR,
  GET_INTAKE_FORMS_SUCCESS,
  GET_MEDIA_FILES,
  GET_MEDIA_FILES_ERROR,
  GET_MEDIA_FILES_SUCCESS,
  GET_PATIENT_CHART_PRINTED_VERSION,
  GET_PATIENT_CHART_PRINTED_VERSION_ERROR,
  GET_PATIENT_CHART_PRINTED_VERSION_SUCCESS,
  GET_PATIENT_INFO,
  GET_PATIENT_INFO_ERROR,
  GET_PATIENT_INFO_SUCCESS,
  GET_PATIENT_PAST_VISITS,
  GET_PATIENT_PAST_VISITS_ERROR,
  GET_PATIENT_PAST_VISITS_SUCCESS,
  GET_PATIENT_UPCOMING_VISITS,
  GET_PATIENT_UPCOMING_VISITS_ERROR,
  GET_PATIENT_UPCOMING_VISITS_SUCCESS,
  GET_PATIENTS_LIST,
  GET_PATIENTS_LIST_ERROR,
  GET_PATIENTS_LIST_SUCCESS,
  GET_PRESCRIPTIONS,
  GET_RESCRIPTIONS_ERROR,
  GET_RESCRIPTIONS_SUCCESS,
  GET_UPCOMING_VISIT_REMARKS,
  GET_UPCOMING_VISIT_REMARKS_ERROR,
  GET_UPCOMING_VISIT_REMARKS_SUCCESS,
  MARK_ALERTS_AS_READ_ERROR,
  REMOVE_UPCOMING_VISIT_REMARK,
  REMOVE_UPCOMING_VISIT_REMARK_ERROR,
  REMOVE_UPCOMING_VISIT_REMARK_SUCCESS,
  RESET_IS_VISIT_CREDIT_UPDATED_SUCCESS,
  RESET_SEARCH_PHARMACY_LIST,
  SEARCH_PHARMACIES,
  SEARCH_PHARMACIES_ERROR,
  SEARCH_PHARMACIES_SUCCESS,
  SET_ERROR,
  SET_IS_ACCOUNT_UPDATED_SUCCESS,
  SET_IS_ALERT_ADDED_SUCCESS,
  SET_IS_ALERTS_LOADED_SUCCESS,
  SET_IS_ALLERGY_ADDED_SUCCESS,
  SET_IS_ALLERGY_DELETED_SUCCESS,
  SET_IS_GENERAL_INFO_UPDATED_SUCCESS,
  SET_IS_PATIENT_INFO_LOADED_SUCCESS,
  SET_IS_PHARMACIES_SEARCHING_DONE,
  SET_IS_PRINTED_VERSION_OF_CHARTS_READY,
  SET_MEDIA_FILE_TAGS,
  SET_MEDIA_FILE_TAGS_ERROR,
  SET_MEDIA_FILE_TAGS_SUCCESS,
  SET_NEW_PATIENTS_LIST,
  SET_ON_HOLD_STATUS,
  SET_ON_HOLD_STATUS_ERROR,
  SET_ON_HOLD_STATUS_SUCCESS,
  SET_PATIENT_HAS_ALLERGIES,
  SET_PATIENT_HAS_ALLERGIES_ERROR,
  SET_PATIENT_HAS_ALLERGIES_SUCCESS,
  SET_PATIENT_HAS_NO_ALLERGIES,
  SET_PATIENT_HAS_NO_ALLERGIES_ERROR,
  SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  SET_PATIENT_INFO,
  SET_PATIENT_PAST_VISITS,
  SET_PATIENT_STATUS_CHANGED_SUCCESS,
  SET_PATIENT_UPCOMING_VISITS,
  SET_PATIENTS_LIST,
  SET_PHONE_VALIDATION,
  UPDATE_ACCOUNT_INFO,
  UPDATE_ACCOUNT_INFO_ERROR,
  UPDATE_ACCOUNT_INFO_SUCCESS,
  UPDATE_GENERAL_INFO,
  UPDATE_GENERAL_INFO_ERROR,
  UPDATE_GENERAL_INFO_SUCCESS,
  UPDATE_UPCOMING_VISIT_REMARK,
  UPDATE_UPCOMING_VISIT_REMARK_ERROR,
  UPDATE_UPCOMING_VISIT_REMARK_SUCCESS,
  UPDATE_VISIT_CREDIT,
  UPDATE_VISIT_CREDIT_ERROR,
  UPDATE_VISIT_CREDIT_SUCCESS,
  VALIDATE_PHONE_NUMBER,
  VALIDATE_PHONE_NUMBER_ERROR,
  VALIDATE_PHONE_NUMBER_SUCCESS,
  SET_ON_HOLD_STATUS_WITH_REASON,
  SET_ON_HOLD_STATUS_WITH_REASON_SUCCESS,
  SET_ON_HOLD_STATUS_WITH_REASON_ERROR,
  ADD_RECENTLY_VIEWED_CHART,
} from './ChartsConstants'
import { GET_DRUG_RULES_SETTINGS_ERROR } from '../drugRulesSettings/drugRulesSettingsConstants'
import { SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS } from '../file-pop-up/FilePopUpConstants'
import { GET_PATIENT_INFORMATION_SUCCESS } from '../patient/PatientConstants'
import {
  MANUALLY_VERIFY_ID_SUCCESS,
  SEND_VERIFICATION_INVITE_SUCCESS,
} from '../id-verification-pop-up/IDVerificationPopUpConstants'
import {
  getRecentlyViewedCharts,
  MAX_RECENTLY_VIEWED,
  type RecentlyViewedChart,
} from '../../pages/patient-charts/recentlyViewed'
import { REHYDRATE } from 'redux-persist'

const initialState = {
  loading: false,
  error: '',
  newPatientsList: null,
  patientsList: [],
  recentlyViewed: getRecentlyViewedCharts(),
  remarks: null,
  patientInfo: {},
  foundPharmaciesCollection: null,
  isPatientInfoLoadedSuccess: false,
  isAllergyDeletedSuccess: false,
  isAllergyAddedSuccess: false,
  isAlertAddedSuccess: false,
  isAlertsLoadedSuccess: false,
  isAccountUpdatedSuccess: false,
  isPharmacySearchingDone: false,
  isVisitCreditUpdatedSuccess: false,
  isGeneralInfoUpdatedSuccess: false,
  intakeForm: {},
  patientChartPrintedInfo: {},
  isPrintVersionOfChartsReadyToBePrinted: false,
  isPatientStatusChangedSuccess: false,
}
const FILE_FORMATS = '.pdf; .doc; .docx; .jpg; .jpeg; .png; .bmp'

export default function chartsReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case REHYDRATE: {
      // redux-persist rehydrates state from a previous session. If the persisted
      // state predates the recentlyViewed field, seed it from localStorage so
      // existing users don't crash on the missing property.
      // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
      const incomingCharts = action.payload?.chartsReducer
      return {
        ...state,
        ...incomingCharts,
        recentlyViewed: incomingCharts?.recentlyViewed ?? getRecentlyViewedCharts(),
      }
    }
    case GET_PATIENTS_LIST:
    case GET_PATIENT_INFO:
    case GET_PATIENT_CHART_PRINTED_VERSION:
    case GET_PRESCRIPTIONS:
    case GET_AUDI_LOGS:
    case GET_ALERTS_LIST:
    case DELETE_ALLERGY:
    case ADD_ALERT:
    case UPDATE_VISIT_CREDIT:
    case UPDATE_ACCOUNT_INFO:
    case EDIT_ALERT:
    case DELETE_ALERT:
    case ADD_ALLERGY:
    case SET_MEDIA_FILE_TAGS:
    case GET_MEDIA_FILES:
    case ADD_MEDIA_FILE:
    case GET_PATIENT_PAST_VISITS:
    case SET_ON_HOLD_STATUS:
    case GET_INTAKE_FORMS:
    case GET_INTAKE_FORM:
    case GET_PATIENT_UPCOMING_VISITS:
    case UPDATE_GENERAL_INFO:
    case SET_PATIENT_HAS_ALLERGIES:
    case GET_UPCOMING_VISIT_REMARKS:
    case CREATE_UPCOMING_VISIT_REMARK:
    case UPDATE_UPCOMING_VISIT_REMARK:
    case REMOVE_UPCOMING_VISIT_REMARK:
    case SET_ON_HOLD_STATUS_WITH_REASON:
    case SET_PATIENT_HAS_NO_ALLERGIES: {
      return {
        ...state,
        loading: true,
      }
    }
    case SEARCH_PHARMACIES:
      return {
        ...state,
        error: '',
        loading: true,
        foundPharmaciesCollection: null,
        isPharmacySearchingDone: false,
      }
    case CREATE_UPCOMING_VISIT_REMARK_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { visitId } = action.extraData
      const visitRemarks = state.remarks?.[visitId]
      return {
        ...state,
        loading: false,
        remarks: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state.remarks,
          [visitId]: {
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            ...visitRemarks,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            remarksList: [...(visitRemarks?.remarksList || []), action.payload],
          },
        },
      }
    }
    case SET_ON_HOLD_STATUS_WITH_REASON_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { patientId, newStatus } = action.extraData

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const restrictionStatus = action.payload?.accountRestrictionStatus

      return {
        ...state,
        loading: false,

        isPatientStatusChangedSuccess: true,
        patientInfo: {
          ...state.patientInfo,
          [patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[patientId],
            RestrictionStatus: newStatus,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            RestrictionReason: action.payload?.reason || null,
            IsActive: restrictionStatus === 'none',
          },
        },
      }
    }
    case UPDATE_UPCOMING_VISIT_REMARK_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { visitId, remarkId } = action.extraData
      const visitRemarks = state.remarks?.[visitId]
      return {
        ...state,
        loading: false,
        remarks: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state.remarks,
          [visitId]: {
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            ...visitRemarks,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            remarksList: (visitRemarks?.remarksList || []).map((remark) =>
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              remark.RemarkId === remarkId ? { ...action.payload.data } : remark,
            ),
          },
        },
      }
    }
    case REMOVE_UPCOMING_VISIT_REMARK_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { visitId, remarkId } = action.extraData
      const visitRemarks = state.remarks?.[visitId]
      return {
        ...state,
        loading: false,
        remarks: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state.remarks,
          [visitId]: {
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            ...visitRemarks,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            remarksList: (visitRemarks?.remarksList || []).filter((remark) => remark.RemarkId !== remarkId),
          },
        },
      }
    }
    case GET_PATIENT_CHART_PRINTED_VERSION_SUCCESS:
      return {
        ...state,
        error: '',
        loading: false,
        patientChartPrintedInfo: {
          ...state.patientChartPrintedInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: action.payload,
        },
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPrintVersionOfChartsReadyToBePrinted: action.extraData.patientId,
      }
    case SET_PATIENT_HAS_ALLERGIES_SUCCESS:
      return {
        ...state,
        loading: false,
        patientInfo: {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            AllergyCollection: {
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              ...state.patientInfo[action.extraData.patientId].AllergyCollection,
              HasNoAllergyConfirmation: false,
            },
          },
        },
      }
    case GET_UPCOMING_VISIT_REMARKS_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { visitId } = action.extraData
      return {
        ...state,
        remarks: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state.remarks,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [visitId]: { remarksList: action.payload },
          visitId,
        },
        loading: false,
      }
    case SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS:
      return {
        ...state,
        loading: false,
        patientInfo: {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            AllergyCollection: { Allergies: [], HasNoAllergyConfirmation: true },
          },
        },
      }
    case SET_IS_PRINTED_VERSION_OF_CHARTS_READY:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPrintVersionOfChartsReadyToBePrinted: action.payload,
      }
    case SET_NEW_PATIENTS_LIST:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        newPatientsList: action.payload,
      }
    case GET_INTAKE_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        intakeForm: action.payload,
      }
    case VALIDATE_PHONE_NUMBER:
      return {
        ...state,
        loading: true,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            phoneIsValid: null,
          },
        },
      }
    case SET_ON_HOLD_STATUS_SUCCESS: {
      const getPatientsListWithCorrectStatuses = () => {
        const clonePatientsList = state.patientsList
        const patientInfoFromPatientsList = clonePatientsList.find(
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          ({ PatientId }) => PatientId === action.extraData.patientId,
        )

        if (patientInfoFromPatientsList) {
          return clonePatientsList.map((patientInfoConfig) => {
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            if (patientInfoConfig.PatientId === action.extraData.patientId) {
              return {
                // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                ...patientInfoConfig,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                IsActive: !action.extraData.newStatus,
              }
            }
            return patientInfoConfig
          })
        }

        return clonePatientsList
      }

      return {
        ...state,
        isPatientStatusChangedSuccess: true,
        patientsList: getPatientsListWithCorrectStatuses(),
        patientInfo: {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            IsActive: !action.extraData.newStatus,
          },
        },
      }
    }
    case SEND_VERIFICATION_INVITE_SUCCESS:
    case MANUALLY_VERIFY_ID_SUCCESS: {
      const updatedChartPatientsList = JSON.parse(JSON.stringify(state.patientsList))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedChartPatientsList.forEach((patient, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (patient.PatientId === action.extraData.patientId) {
          patient.IdentityVerification.Status =
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            action.type === SEND_VERIFICATION_INVITE_SUCCESS ?
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action.payload.data.Status
            : ID_VERIFICATION_STATUSES.manuallyverified
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.IdentityVerification.RequestDateTime = action.payload?.data?.RequestDateTime
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedChartPatientsList[index] = patient
        }
      })
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const hasPatientInfo = state.patientInfo[action.extraData.patientId]

      // Update recentlyViewed independently of patientsList — patientsList may be
      // empty when the user is in Recently Viewed mode (no active search), so we
      // cannot rely on the forEach above to capture the new status values.
      const updatedRecentlyViewed = state.recentlyViewed.map((entry) => {
        // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
        if (entry.PatientId !== action.extraData.patientId) return entry
        return {
          ...entry,
          IdentityVerification: {
            ...entry.IdentityVerification,
            Status:
              // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
              action.type === SEND_VERIFICATION_INVITE_SUCCESS ?
                // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
                action.payload.data.Status
              : ID_VERIFICATION_STATUSES.manuallyverified,
            RequestDateTime:
              // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
              action.type === SEND_VERIFICATION_INVITE_SUCCESS ? (action.payload.data.RequestDateTime ?? null) : null,
          },
        }
      })

      return {
        ...state,
        patientsList: updatedChartPatientsList,
        recentlyViewed: updatedRecentlyViewed,
        patientInfo:
          hasPatientInfo ?
            {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                IdentityVerification: {
                  // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                  ...state.patientInfo[action.extraData.patientId].IdentityVerification,
                  // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                  ...state.patientInfo[action.extraData.patientId],
                  RequestDateTime:
                    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                    action.type === SEND_VERIFICATION_INVITE_SUCCESS ? action.payload.data.RequestDateTime : null,
                  Status:
                    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                    action.type === SEND_VERIFICATION_INVITE_SUCCESS ?
                      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                      action.payload.data.Status
                    : ID_VERIFICATION_STATUSES.manuallyverified,
                },
              },
            }
          : state.patientInfo,
      }
    }

    case ADD_RECENTLY_VIEWED_CHART: {
      // @ts-expect-error TS2339 -- action is typed as {} because chartsReducer has no typed action union yet
      const chart: RecentlyViewedChart = { ...action.payload, viewedAt: Date.now() }
      const withoutDuplicate = state.recentlyViewed.filter((entry) => entry.PatientId !== chart.PatientId)
      return {
        ...state,
        recentlyViewed: [chart, ...withoutDuplicate].slice(0, MAX_RECENTLY_VIEWED),
      }
    }

    case GET_PATIENT_INFORMATION_SUCCESS: {
      const updatedChartPatientsList = JSON.parse(JSON.stringify(state.patientsList))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedChartPatientsList.forEach((patient, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (patient.PatientId === action.extraData.patientId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.DrugScreen = action.payload.DrugScreen
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.IdentityVerification = action.payload.IdentityVerification
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedChartPatientsList[index] = patient
        }
      })
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const hasPatientInfo = state.patientInfo[action.extraData.patientId]

      const updatedRecentlyViewed = state.recentlyViewed.map((entry) => {
        // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
        if (entry.PatientId !== action.extraData.patientId) return entry
        return {
          ...entry,
          // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
          DrugScreen: action.payload.DrugScreen,
          // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
          IdentityVerification: action.payload.IdentityVerification,
        }
      })

      return {
        ...state,
        patientsList: updatedChartPatientsList,
        recentlyViewed: updatedRecentlyViewed,
        patientInfo:
          hasPatientInfo ?
            {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                DrugScreen: action.payload.DrugScreen,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                IdentityVerification: action.payload.IdentityVerification,
              },
            }
          : state.patientInfo,
      }
    }
    case SET_MEDIA_FILE_TAGS_SUCCESS:
    case SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS:
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const hasPatientInfo = state.patientInfo[action.extraData.patientId]
      const updatedMediaFiles = JSON.parse(
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        JSON.stringify(state.patientInfo[action.extraData.patientId]?.mediaFiles || []),
      )
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedMediaFiles.forEach((file, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (file.FileId === action.payload.data.FileId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          file = action.payload.data
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedMediaFiles[index] = file
        }
      })
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: action.type === SET_MEDIA_FILE_TAGS_SUCCESS ? false : state.loading,
        patientInfo:
          hasPatientInfo ?
            {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                // @ts-expect-error TS2488 -- MIGRATION: not approved, fix when encountered
                mediaFiles: [...updatedMediaFiles],
              },
            }
          : state.patientInfo,
      }
    case VALIDATE_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        loading: false,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            phoneIsValid: true,
          },
        },
      }
    case GET_RESCRIPTIONS_SUCCESS: {
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            patientPrescriptionsList: action.payload,
          },
        },
        loading: false,
      }
    }
    case GET_GET_AUDI_LOGS_SUCCESS: {
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            patientAuditLogs: action.payload,
          },
        },
        loading: false,
      }
    }
    case ADD_MEDIA_FILE_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { patientId } = action.extraData
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const newMediaFile = action.payload
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const existingPatientInfo = state.patientInfo[patientId] || {}
      const existingMediaFiles = existingPatientInfo.mediaFiles || []

      return {
        ...state,
        loading: false,
        patientInfo: {
          ...state.patientInfo,
          [patientId]: {
            ...existingPatientInfo,
            MediaFileSummary: {
              Count: (existingPatientInfo.MediaFileSummary?.Count || 0) + 1,
            },
            mediaFiles: [newMediaFile, ...existingMediaFiles],
          },
        },
      }
    }
    case GET_MEDIA_FILES_SUCCESS: {
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            mediaFiles: action.payload,
          },
        },
        loading: false,
      }
    }
    case DELETE_MEDIA_FILE_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { patientId, fileId } = action.extraData
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const existingPatientInfo = state.patientInfo[patientId] || {}
      const existingMediaFiles = existingPatientInfo.mediaFiles || []
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      const updatedMediaFiles = existingMediaFiles.filter((file) => file.FileId !== fileId)
      const wasRemoved = updatedMediaFiles.length !== existingMediaFiles.length
      const currentCount = existingPatientInfo.MediaFileSummary?.Count || 0

      return {
        ...state,
        loading: false,
        patientInfo: {
          ...state.patientInfo,
          [patientId]: {
            ...existingPatientInfo,
            MediaFileSummary: {
              ...existingPatientInfo.MediaFileSummary,
              Count: wasRemoved ? Math.max(currentCount - 1, 0) : currentCount,
            },
            mediaFiles: updatedMediaFiles,
          },
        },
      }
    }
    case DELETE_MEDIA_FILE_ERROR:
      return {
        ...state,
        loading: false,
        error:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload?.ErrorCode === apiErrorCodes.PERMISSION ?
            getUserFriendlyErrorMessage(errorCodes.NO_PERMISSION_TO_DELETE_FILE)
          : getUserFriendlyErrorMessage(errorCodes.DEFAULT),
      }
    case SET_PATIENT_STATUS_CHANGED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPatientStatusChangedSuccess: action.payload,
      }
    }
    case RESET_SEARCH_PHARMACY_LIST:
      return {
        ...state,
        foundPharmaciesCollection: null,
      }
    case GET_PATIENT_PAST_VISITS_SUCCESS:
      return {
        ...state,
        loading: false,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            PastVisits: action.payload,
          },
        },
      }
    case SET_PATIENT_PAST_VISITS:
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.payload.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            PastVisits: action.payload.value,
          },
        },
      }
    case GET_PATIENT_UPCOMING_VISITS_SUCCESS:
      return {
        ...state,
        loading: false,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            UpcomingVisits: action.payload,
          },
        },
      }
    case SET_PATIENT_UPCOMING_VISITS:
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.payload.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            UpcomingVisits: action.payload.value,
          },
        },
      }
    case GET_PATIENTS_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        patientsList:
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.extraData.isUpdatePatientsList ? action.payload : [...state.patientsList, ...action.payload],
      }
    }
    case GET_PATIENT_INFO_SUCCESS: {
      const updatedChartPatientsList = JSON.parse(JSON.stringify(state.patientsList))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedChartPatientsList.forEach((patient, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (patient.PatientId === action.extraData.patientId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.DrugScreen = action.payload.DrugScreen
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.IdentityVerification = action.payload.IdentityVerification
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedChartPatientsList[index] = patient
        }
      })

      const updatedRecentlyViewedForPatientInfo = state.recentlyViewed.map((entry) => {
        // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
        if (entry.PatientId !== action.payload.PatientId) return entry
        return {
          ...entry,
          // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
          DrugScreen: action.payload.DrugScreen,
          // @ts-expect-error TS2339 -- action is untyped ({}); chartsReducer needs a typed action union to fix properly
          IdentityVerification: action.payload.IdentityVerification,
        }
      })

      return {
        ...state,
        patientsList: updatedChartPatientsList,
        recentlyViewed: updatedRecentlyViewedForPatientInfo,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        loading: !!action.extraData.mediaFiles,
        isPatientInfoLoadedSuccess: true,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.PatientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state?.patientInfo?.[action?.payload?.PatientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            ...action.payload,
            phoneIsValid: null,
          },
        },
      }
    }
    case GET_INTAKE_FORMS_SUCCESS: {
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            IntakeFormsList: Object.keys(action.payload).length ? action.payload : null,
          },
        },
        loading: false,
      }
    }
    case GET_ALERTS_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        isAlertsLoadedSuccess: true,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            Alerts: action.payload,
          },
        },
      }
    }
    case UPDATE_ACCOUNT_INFO_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { patientId, newAccountInfo, newPharmacyInfo } = action.extraData
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const currentPatientInfo = state.patientInfo[patientId] ?? {}

      const updatedPatientInfo = {
        ...currentPatientInfo,
        Address: newAccountInfo.Address || currentPatientInfo.Address,
        BirthDate: newAccountInfo.BirthDate,
        EmergencyContact: newAccountInfo.EmergencyContact,
        FirstName: newAccountInfo.FirstName,
        LastName: newAccountInfo.LastName,
        PhoneNumber: newAccountInfo.PhoneNumber || currentPatientInfo.PhoneNumber,
        PreferredName: newAccountInfo.PreferredName,
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        Email: newAccountInfo?.Email || state.patientInfo?.[patientId]?.Email,
        Pharmacy:
          newPharmacyInfo ?
            {
              ...currentPatientInfo.Pharmacy,
              ...newPharmacyInfo,
            }
          : currentPatientInfo.Pharmacy,
      }

      const getPatientsListWithUpdatedInfo = () => {
        const clonePatientsList = state.patientsList
        const patientInfoFromPatientsList = clonePatientsList.find(({ PatientId }) => PatientId === patientId)

        if (patientInfoFromPatientsList) {
          return clonePatientsList.map((patientInfoConfig) => {
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            if (patientInfoConfig.PatientId === patientId) {
              return {
                // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                ...patientInfoConfig,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                BirthDate: updatedPatientInfo?.BirthDate || patientInfoConfig.BirthDate,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                Email: updatedPatientInfo?.Email || patientInfoConfig.Email,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                FirstName: updatedPatientInfo?.FirstName || patientInfoConfig.FirstName,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                LastName: updatedPatientInfo?.LastName || patientInfoConfig.LastName,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                PhoneNumber: updatedPatientInfo?.PhoneNumber || patientInfoConfig.PhoneNumber,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                StateCode: updatedPatientInfo?.Address?.StateCode || patientInfoConfig.StateCode,
              }
            }
            return patientInfoConfig
          })
        }

        return clonePatientsList
      }

      return {
        ...state,
        patientsList: getPatientsListWithUpdatedInfo(),
        patientInfo: {
          ...state.patientInfo,
          [patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[patientId],
            ...updatedPatientInfo,
          },
        },
        loading: false,
        isAccountUpdatedSuccess: true,
      }
    }
    case UPDATE_GENERAL_INFO_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { patientId, newGeneralInfo } = action.extraData

      const getPatientsListWithUpdatedInfo = () => {
        const clonePatientsList = state.patientsList
        const patientInfoFromPatientsList = clonePatientsList.find(({ PatientId }) => PatientId === patientId)

        if (patientInfoFromPatientsList) {
          return clonePatientsList.map((patientInfoConfig) => {
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            if (patientInfoConfig.PatientId === patientId) {
              return {
                // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                ...patientInfoConfig,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                Gender: newGeneralInfo?.Gender?.toLowerCase() || patientInfoConfig.Gender,
              }
            }
            return patientInfoConfig
          })
        }

        return clonePatientsList
      }
      getPatientsListWithUpdatedInfo()
      return {
        ...state,
        loading: false,
        patientsList: getPatientsListWithUpdatedInfo(),
        isGeneralInfoUpdatedSuccess: true,
      }
    }
    case UPDATE_VISIT_CREDIT_SUCCESS: {
      return {
        ...state,
        loading: false,
        isVisitCreditUpdatedSuccess: true,
      }
    }
    case ADD_ALLERGY_SUCCESS: {
      return {
        ...state,
        loading: false,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            AllergyCollection: {
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              ...state.patientInfo[action.extraData.patientId].AllergyCollection,
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              Allergies: [...state.patientInfo[action.extraData.patientId].AllergyCollection.Allergies, action.payload],
              HasNoAllergyConfirmation: false,
            },
          },
        },
        isAllergyAddedSuccess: true,
      }
    }
    case DELETE_ALLERGY_SUCCESS: {
      return {
        ...state,
        loading: false,
        isAllergyDeletedSuccess: true,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            AllergyCollection: {
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              ...state.patientInfo[action.extraData.patientId].AllergyCollection,
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              Allergies: state.patientInfo[action.extraData.patientId].AllergyCollection.Allergies.filter(
                // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                (allergy) => allergy.AllergyId !== action.extraData.allergyId,
              ),
            },
          },
        },
      }
    }
    case DELETE_ALERT_SUCCESS:
    case EDIT_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case ADD_ALERT_SUCCESS: {
      return {
        ...state,
        loading: false,
        isAlertAddedSuccess: true,
      }
    }
    case SET_PATIENTS_LIST: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientsList: action.payload,
      }
    }
    case SEARCH_PHARMACIES_SUCCESS: {
      return {
        ...state,
        loading: false,
        isPharmacySearchingDone: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        foundPharmaciesCollection: action.payload,
      }
    }
    case SET_IS_PHARMACIES_SEARCHING_DONE: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPharmacySearchingDone: action.payload,
      }
    }
    case SET_IS_PATIENT_INFO_LOADED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPatientInfoLoadedSuccess: action.payload,
      }
    }
    case SET_IS_ALERTS_LOADED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isAlertsLoadedSuccess: action.payload,
      }
    }
    case SET_IS_ALLERGY_ADDED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isAllergyAddedSuccess: action.payload,
      }
    }
    case SET_IS_ACCOUNT_UPDATED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isAccountUpdatedSuccess: action.payload,
      }
    }
    case SET_IS_GENERAL_INFO_UPDATED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isGeneralInfoUpdatedSuccess: action.payload,
      }
    }
    case RESET_IS_VISIT_CREDIT_UPDATED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isVisitCreditUpdatedSuccess: action.payload,
      }
    }
    case SET_IS_ALERT_ADDED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isAlertAddedSuccess: action.payload,
      }
    }
    case SET_IS_ALLERGY_DELETED_SUCCESS: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isAllergyDeletedSuccess: action.payload,
      }
    }
    case SET_PATIENT_INFO: {
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.patientId]: action.payload,
        },
      }
    }
    case SET_ERROR: {
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
      }
    }
    case VALIDATE_PHONE_NUMBER_ERROR:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      switch (action.payload.ErrorCode) {
        case PHONE_NUMBER_NOT_VALID:
          return {
            ...state,
            loading: false,
            patientInfo: {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                phoneIsValid: false,
              },
            },
          }
        case apiErrorCodes.THIRD_PARTY_ERROR: {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          const { ErrorCode, ErrorMessage } = action.payload.Data
          const message = `${ErrorCode} - ${ErrorMessage}`
          return {
            ...state,
            loading: false,
            error: message,
            patientInfo: {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                phoneIsValid: false,
              },
            },
          }
        }
        case apiErrorCodes.FORBIDDEN:
          return {
            ...state,
            error:
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action?.extraData?.isUpdateAccountInfoRequest ?
                getUserFriendlyErrorMessage(errorCodes.THIS_PHONE_NUMBER_CONNOT_BE_USED)
              : getUserFriendlyErrorMessage(errorCodes.FORBIDDEN_ACTION),
            loading: false,
          }

        default:
          return {
            ...state,
            error:
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action.payload.UserFriendlyErrorCode ?
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode)
              : getUserFriendlyErrorMessage(errorCodes.DEFAULT),
            loading: false,
          }
      }
    case GET_PATIENTS_LIST_ERROR:
    case GET_PATIENT_INFO_ERROR:
    case GET_ALERTS_LIST_ERROR:
    case GET_RESCRIPTIONS_ERROR:
    case GET_GET_AUDI_LOGS_ERROR:
    case MARK_ALERTS_AS_READ_ERROR:
    case DELETE_ALLERGY_ERROR:
    case ADD_ALERT_ERROR:
    case UPDATE_ACCOUNT_INFO_ERROR:
    case GET_PATIENT_CHART_PRINTED_VERSION_ERROR:
    case UPDATE_VISIT_CREDIT_ERROR:
    case ADD_ALLERGY_ERROR:
    case DELETE_ALERT_ERROR:
    case EDIT_ALERT_ERROR:
    case GET_PATIENT_PAST_VISITS_ERROR:
    case GET_PATIENT_UPCOMING_VISITS_ERROR:
    case UPDATE_UPCOMING_VISIT_REMARK_ERROR:
    case GET_MEDIA_FILES_ERROR:
    case GET_INTAKE_FORM_ERROR:
    case SET_MEDIA_FILE_TAGS_ERROR:
    case ADD_MEDIA_FILE_ERROR:
    case GET_INTAKE_FORMS_ERROR:
    case CREATE_UPCOMING_VISIT_REMARK_ERROR:
    case GET_DRUG_RULES_SETTINGS_ERROR:
    case SET_ON_HOLD_STATUS_ERROR:
    case GET_UPCOMING_VISIT_REMARKS_ERROR:
    case UPDATE_GENERAL_INFO_ERROR:
    case REMOVE_UPCOMING_VISIT_REMARK_ERROR:
    case SET_PATIENT_HAS_ALLERGIES_ERROR:
    case SET_PATIENT_HAS_NO_ALLERGIES_ERROR:
    case SET_ON_HOLD_STATUS_WITH_REASON_ERROR:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      switch (action.payload.ErrorCode) {
        case PHONE_NUMBER_NOT_VALID:
          return {
            ...state,
            loading: false,
            error: getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS),
            patientInfo: {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                phoneIsValid: false,
              },
            },
          }
        case apiErrorCodes.THIRD_PARTY_ERROR: {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          const { ErrorCode, ErrorMessage } = action.payload.Data
          const message = `${ErrorCode} - ${ErrorMessage}`
          return {
            ...state,
            loading: false,
            error: message,
            patientInfo: {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                phoneIsValid: false,
              },
            },
          }
        }
        case apiErrorCodes.GENDER_NOT_VALID:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, GENDER),
            loading: false,
          }
        case PATIENT_NOT_FOUND_ERROR:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, PATIENT_TEXT),
            loading: false,
          }
        case EMAIL_NOT_UNIQUE_ERROR:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.NAME_ALREADY_EXISTS, null, EMAIL_TEXT),
            loading: false,
          }
        case ALLERGY_NAME_NOT_UNIQUE:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.ALLERGY_NAME_NOT_UNIQUE),
            loading: false,
          }
        case ALLERGY_NAME_NOT_VALID:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.ONLY_NUMBERS_AND_LETTERS_ALLOWED),
            loading: false,
          }
        case apiErrorCodes.MESSAGE_NOT_VALID:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, MESSAGE_TEXT),
            loading: false,
          }
        case apiErrorCodes.ALERT_NOT_FOUND:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, ALERTS_TEXT),
            loading: false,
          }

        case apiErrorCodes.FORBIDDEN:
          return {
            ...state,
            error:
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action?.extraData?.isUpdateAccountInfoRequest ?
                getUserFriendlyErrorMessage(errorCodes.THIS_PHONE_NUMBER_CONNOT_BE_USED)
              : getUserFriendlyErrorMessage(errorCodes.FORBIDDEN_ACTION),
            loading: false,
          }
        case apiErrorCodes.COUNT_NOT_VALID:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, COUNT),
            loading: false,
          }

        case apiErrorCodes.OFFSET_NOT_VALID:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, OFFSET),
            loading: false,
          }
        case apiErrorCodes.FILE_NOT_FOUND:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, FILE_LOWER),
            loading: false,
          }
        case apiErrorCodes.FILE_NOT_VALID:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.INVALID_FILE_FORMAT, null, FILE_FORMATS),
            loading: false,
          }
        case apiErrorCodes.FILE_TAG_NOT_VALID:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, FILE_TAG_LOWER),
            loading: false,
          }
        case apiErrorCodes.CREDIT_AMOUNT_NOT_VALID:
          return {
            ...state,
            error: getUserFriendlyErrorMessage(errorCodes.CANNOT_SAVE_NEGATIVE_BALANCE),
            loading: false,
          }

        default:
          return {
            ...state,
            error:
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action.payload.UserFriendlyErrorCode ?
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode)
              : getUserFriendlyErrorMessage(errorCodes.DEFAULT),
            loading: false,
          }
      }
    case SET_PHONE_VALIDATION:
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload?.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state?.patientInfo?.[action.payload?.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            phoneIsValid: action.payload.value,
          },
        },
      }

    case SEARCH_PHARMACIES_ERROR:
      return {
        ...state,
        error: getUserFriendlyErrorMessage(errorCodes.DEFAULT),
        loading: false,
        isPharmacySearchingDone: true,
      }
    case LOGOUT:
      return initialState
    default:
      return state
  }
}
